import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

interface FeedbackState {
  feedbacks: Record<string, { liked: boolean; disliked: boolean }>;
}

const initialState: FeedbackState = {
  feedbacks: {},
};

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    setFeedback: (state, action) => {
      const { messageId, liked, disliked } = action.payload;
      state.feedbacks[messageId] = { liked, disliked };
    },
  },
});

export const { setFeedback } = feedbackSlice.actions;

export const getFeedback = (state: RootState, messageId: string) =>
  state.feedback.feedbacks[messageId] || { liked: false, disliked: false };

export default feedbackSlice.reducer;